import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchGenres'
})

export class SearchGenresPipe implements PipeTransform {

  transform(pipeData, pipeModifier): any {
    if (pipeModifier != 'GENRE') {
      return pipeData.filter(eachItem => {
        if (eachItem['fields']['genres']) {
          return (
            eachItem['fields']['genres'].includes(pipeModifier)
          )
        }
      });
    } else {
      return pipeData
    }
  }
}